






import { Component, Vue } from 'vue-property-decorator';
import { WebimModuleMapper } from '@/store/modules/webimSdk';
import { ConstantsModuleMapper } from '@/store/modules/constants';
import { ConfigsModuleMapper } from '@/store/modules/config';

import Icon from '@/components/common/icon.vue';

const Mappers = Vue.extend({
  computed: {
    ...ConfigsModuleMapper.mapGetters(['punterHash']),
    ...ConstantsModuleMapper.mapGetters(['chat']),
    ...WebimModuleMapper.mapGetters(['setup']),
  },
  methods: {
    ...WebimModuleMapper.mapMutations(['updateAccessScriptError']),
  },
});

@Component({
  components: {
    Icon,
  },
})
export default class RuChatButtonComponent extends Mappers {
  openChat() {
    try {
      // @ts-ignore
      return window.webim && window.webim.api?.chat.start();
    } catch (e) {
      this.updateAccessScriptError(true);
    }
    return false;
  }

  get url() {
    return `//${this.setup.domain}/button.php?location=${this.punterHash ? 'BOTauthorized' : 'BOTunauthorized'}`;
  }

  mounted() {
    // @ts-ignore
    window.webim = {
      accountName: this.setup.accountName,
      domain: this.setup.domain,
      location: this.punterHash ? 'BOTauthorized' : 'BOTunauthorized',
    };
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = `http://${this.setup.domain}/js/button.js`;
    s.src = `https://${this.setup.domain}/js/button.js`;
    document.getElementsByTagName('head')[0].appendChild(s);
  }
}
